import CloseIcon from "@mui/icons-material/Close";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import ProjectCommentSection from "./ProjectCommentSection";

export default function ProjectCommentsDialog(props) {
    function handleClose() {
        props.onClose(false);
    }

    return (
        <Dialog
            onClose={handleClose}
            open={props.open}
            fullWidth
            maxWidth="md"
            aria-labelledby="project-comments-dialog-title"
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 3,
                        overflow: "hidden",
                        maxHeight: "90vh",
                    },
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    px: { xs: 2, sm: 3 },
                    py: 2.25,
                }}
            >
                <Box
                    sx={{
                        width: 42,
                        height: 42,
                        display: "grid",
                        placeItems: "center",
                        flexShrink: 0,
                        borderRadius: 2,
                        color: "primary.main",
                        backgroundColor: "rgba(0, 149, 61, 0.09)",
                    }}
                >
                    <MessageOutlinedIcon />
                </Box>
                <Box sx={{ flex: 1 }}>
                    <Typography
                        id="project-comments-dialog-title"
                        variant="h5"
                        component="h2"
                    >
                        Comments
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Discuss this part of the project.
                    </Typography>
                </Box>
                <IconButton aria-label="Close comments" onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <DialogContent
                dividers
                sx={{ p: 0, backgroundColor: "background.default" }}
            >
                <ProjectCommentSection
                    component={props.component}
                    projectKey={props.projectKey}
                    canEdit={props.canEdit}
                />
            </DialogContent>
        </Dialog>
    );
}
